import styled from 'styled-components';

export const CommunityUserTypeWrapper = styled.div`
  display: flex;
`;
